import { createSlice } from "@reduxjs/toolkit";
import { GetCampaign } from "../Apis/GetCampaign";

export const GetCampaignSlice = createSlice({
  name: "getcampaign",
  initialState: {
    getcampaign: null,
    authenticatinggetcampaign: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.getcampaign = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatinggetcampaign = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(GetCampaign.fulfilled, (state, action) => {
      state.getcampaign = action.payload;
      state.authenticated = false;
      state.authenticatinggetcampaign = false;
      return state;
    });
    builder.addCase(GetCampaign.pending, (state, action) => {
      state.authenticatinggetcampaign = true;
      state.authenticated = true;
    });
    builder.addCase(GetCampaign.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatinggetcampaign = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = GetCampaignSlice.actions;

export const GetCampaignSelector = (state) => state.getcampaign;
